// Exemple d'instruction adapté au produit (plat, boisson chaude/froide, dessert, salade de fruits, autre).
const HOT = /(?<!\p{L})(caf[ée]|th[ée]|infusion|tisane|chocolat chaud|cappuccino|espresso|latte|allong[ée]|noisette|d[ée]ca(f[ée]in[ée])?)(?!\p{L})/iu;
const FRUIT = /salade de fruits|fruit salad/i;
const DRINK_CAT = /boisson|drink|cocktail|bar|jus|soda|vin|bi[èe]re|beer|wine|ap[ée]ritif|soft/i;
const DESSERT_CAT = /dessert|p[âa]tisserie|glace|sweet/i;

const COLD_HINT = /glac[ée]|frapp[ée]|iced|froid|frozen/i;

export function instructionsHint(product, t) {
  if (!product) return t.instrOther;
  const name = product.name || "", cat = product.category || "", station = product.station || "";
  if (FRUIT.test(name) || FRUIT.test(cat)) return t.instrFruitSalad;
  if (DESSERT_CAT.test(cat)) return t.instrDessert;
  if (HOT.test(name) && !COLD_HINT.test(name)) return t.instrHotDrink;
  if (DRINK_CAT.test(cat) || station === "bar") return t.instrColdDrink;
  if (station === "service") return t.instrOther;
  return t.instrDish;
}
